// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-fa364fa7"};